export const timeZoneData = [
  {
    baseUtcOffset: '-PT12H',
    displayName: '(UTC-12:00) International Date Line West',
    id: 'Dateline Standard Time',
    offset: -720
  },
  {
    baseUtcOffset: '-PT11H',
    displayName: '(UTC-11:00) Coordinated Universal Time-11',
    id: 'UTC-11',
    offset: -660
  },
  {
    baseUtcOffset: '-PT10H',
    displayName: '(UTC-10:00) Aleutian Islands',
    id: 'Aleutian Standard Time',
    offset: -600
  },
  {
    baseUtcOffset: '-PT10H',
    displayName: '(UTC-10:00) Hawaii',
    id: 'Hawaiian Standard Time',
    offset: -600
  },
  {
    baseUtcOffset: '-PT9H30M',
    displayName: '(UTC-09:30) Marquesas Islands',
    id: 'Marquesas Standard Time',
    offset: -570
  },
  {
    baseUtcOffset: '-PT9H',
    displayName: '(UTC-09:00) Alaska',
    id: 'Alaskan Standard Time',
    offset: -540
  },
  {
    baseUtcOffset: '-PT9H',
    displayName: '(UTC-09:00) Coordinated Universal Time-09',
    id: 'UTC-09',
    offset: -540
  },
  {
    baseUtcOffset: '-PT8H',
    displayName: '(UTC-08:00) Baja California',
    id: 'Pacific Standard Time (Mexico)',
    offset: -480
  },
  {
    baseUtcOffset: '-PT8H',
    displayName: '(UTC-08:00) Coordinated Universal Time-08',
    id: 'UTC-08',
    offset: -480
  },
  {
    baseUtcOffset: '-PT8H',
    displayName: '(UTC-08:00) Pacific Time (US & Canada)',
    id: 'Pacific Standard Time',
    offset: -480
  },
  {
    baseUtcOffset: '-PT7H',
    displayName: '(UTC-07:00) Arizona',
    id: 'US Mountain Standard Time',
    offset: -420
  },
  {
    baseUtcOffset: '-PT7H',
    displayName: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
    id: 'Mountain Standard Time (Mexico)',
    offset: -420
  },
  {
    baseUtcOffset: '-PT7H',
    displayName: '(UTC-07:00) Mountain Time (US & Canada)',
    id: 'Mountain Standard Time',
    offset: -420
  },
  {
    baseUtcOffset: '-PT7H',
    displayName: '(UTC-07:00) Yukon',
    id: 'Yukon Standard Time',
    offset: -420
  },
  {
    baseUtcOffset: '-PT6H',
    displayName: '(UTC-06:00) Central America',
    id: 'Central America Standard Time',
    offset: -360
  },
  {
    baseUtcOffset: '-PT6H',
    displayName: '(UTC-06:00) Central Time (US & Canada)',
    id: 'Central Standard Time',
    offset: -360
  },
  {
    baseUtcOffset: '-PT6H',
    displayName: '(UTC-06:00) Easter Island',
    id: 'Easter Island Standard Time',
    offset: -360
  },
  {
    baseUtcOffset: '-PT6H',
    displayName: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
    id: 'Central Standard Time (Mexico)',
    offset: -360
  },
  {
    baseUtcOffset: '-PT6H',
    displayName: '(UTC-06:00) Saskatchewan',
    id: 'Canada Central Standard Time',
    offset: -360
  },
  {
    baseUtcOffset: '-PT5H',
    displayName: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco',
    id: 'SA Pacific Standard Time',
    offset: -300
  },
  {
    baseUtcOffset: '-PT5H',
    displayName: '(UTC-05:00) Chetumal',
    id: 'Eastern Standard Time (Mexico)',
    offset: -300
  },
  {
    baseUtcOffset: '-PT5H',
    displayName: '(UTC-05:00) Eastern Time (US & Canada)',
    id: 'Eastern Standard Time',
    offset: -300
  },
  {
    baseUtcOffset: '-PT5H',
    displayName: '(UTC-05:00) Haiti',
    id: 'Haiti Standard Time',
    offset: -300
  },
  {
    baseUtcOffset: '-PT5H',
    displayName: '(UTC-05:00) Havana',
    id: 'Cuba Standard Time',
    offset: -300
  },
  {
    baseUtcOffset: '-PT5H',
    displayName: '(UTC-05:00) Indiana (East)',
    id: 'US Eastern Standard Time',
    offset: -300
  },
  {
    baseUtcOffset: '-PT5H',
    displayName: '(UTC-05:00) Turks and Caicos',
    id: 'Turks And Caicos Standard Time',
    offset: -300
  },
  {
    baseUtcOffset: '-PT4H',
    displayName: '(UTC-04:00) Asuncion',
    id: 'Paraguay Standard Time',
    offset: -240
  },
  {
    baseUtcOffset: '-PT4H',
    displayName: '(UTC-04:00) Atlantic Time (Canada)',
    id: 'Atlantic Standard Time',
    offset: -240
  },
  {
    baseUtcOffset: '-PT4H',
    displayName: '(UTC-04:00) Caracas',
    id: 'Venezuela Standard Time',
    offset: -240
  },
  {
    baseUtcOffset: '-PT4H',
    displayName: '(UTC-04:00) Cuiaba',
    id: 'Central Brazilian Standard Time',
    offset: -240
  },
  {
    baseUtcOffset: '-PT4H',
    displayName: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
    id: 'SA Western Standard Time',
    offset: -240
  },
  {
    baseUtcOffset: '-PT4H',
    displayName: '(UTC-04:00) Santiago',
    id: 'Pacific SA Standard Time',
    offset: -240
  },
  {
    baseUtcOffset: '-PT3H30M',
    displayName: '(UTC-03:30) Newfoundland',
    id: 'Newfoundland Standard Time',
    offset: -210
  },
  {
    baseUtcOffset: '-PT3H',
    displayName: '(UTC-03:00) Araguaina',
    id: 'Tocantins Standard Time',
    offset: -180
  },
  {
    baseUtcOffset: '-PT3H',
    displayName: '(UTC-03:00) Brasilia',
    id: 'E. South America Standard Time',
    offset: -180
  },
  {
    baseUtcOffset: '-PT3H',
    displayName: '(UTC-03:00) Cayenne, Fortaleza',
    id: 'SA Eastern Standard Time',
    offset: -180
  },
  {
    baseUtcOffset: '-PT3H',
    displayName: '(UTC-03:00) City of Buenos Aires',
    id: 'Argentina Standard Time',
    offset: -180
  },
  {
    baseUtcOffset: '-PT3H',
    displayName: '(UTC-03:00) Greenland',
    id: 'Greenland Standard Time',
    offset: -180
  },
  {
    baseUtcOffset: '-PT3H',
    displayName: '(UTC-03:00) Montevideo',
    id: 'Montevideo Standard Time',
    offset: -180
  },
  {
    baseUtcOffset: '-PT3H',
    displayName: '(UTC-03:00) Punta Arenas',
    id: 'Magallanes Standard Time',
    offset: -180
  },
  {
    baseUtcOffset: '-PT3H',
    displayName: '(UTC-03:00) Saint Pierre and Miquelon',
    id: 'Saint Pierre Standard Time',
    offset: -180
  },
  {
    baseUtcOffset: '-PT3H',
    displayName: '(UTC-03:00) Salvador',
    id: 'Bahia Standard Time',
    offset: -180
  },
  {
    baseUtcOffset: '-PT2H',
    displayName: '(UTC-02:00) Coordinated Universal Time-02',
    id: 'UTC-02',
    offset: -120
  },
  {
    baseUtcOffset: '-PT2H',
    displayName: '(UTC-02:00) Mid-Atlantic - Old',
    id: 'Mid-Atlantic Standard Time',
    offset: -120
  },
  {
    baseUtcOffset: '-PT1H',
    displayName: '(UTC-01:00) Azores',
    id: 'Azores Standard Time',
    offset: -60
  },
  {
    baseUtcOffset: '-PT1H',
    displayName: '(UTC-01:00) Cabo Verde Is.',
    id: 'Cape Verde Standard Time',
    offset: -60
  },
  {
    baseUtcOffset: 'PT0S',
    displayName: '(UTC) Coordinated Universal Time',
    id: 'UTC',
    offset: 0
  },
  {
    baseUtcOffset: 'PT0S',
    displayName: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London',
    id: 'GMT Standard Time',
    offset: 0
  },
  {
    baseUtcOffset: 'PT0S',
    displayName: '(UTC+00:00) Monrovia, Reykjavik',
    id: 'Greenwich Standard Time',
    offset: 0
  },
  {
    baseUtcOffset: 'PT0S',
    displayName: '(UTC+00:00) Sao Tome',
    id: 'Sao Tome Standard Time',
    offset: 0
  },
  {
    baseUtcOffset: 'PT0S',
    displayName: '(UTC+01:00) Casablanca',
    id: 'Morocco Standard Time',
    offset: 0
  },
  {
    baseUtcOffset: 'PT1H',
    displayName: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    id: 'W. Europe Standard Time',
    offset: 60
  },
  {
    baseUtcOffset: 'PT1H',
    displayName:
      '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    id: 'Central Europe Standard Time',
    offset: 60
  },
  {
    baseUtcOffset: 'PT1H',
    displayName: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
    id: 'Romance Standard Time',
    offset: 60
  },
  {
    baseUtcOffset: 'PT1H',
    displayName: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
    id: 'Central European Standard Time',
    offset: 60
  },
  {
    baseUtcOffset: 'PT1H',
    displayName: '(UTC+01:00) West Central Africa',
    id: 'W. Central Africa Standard Time',
    offset: 60
  },
  {
    baseUtcOffset: 'PT2H',
    displayName: '(UTC+02:00) Amman',
    id: 'Jordan Standard Time',
    offset: 120
  },
  {
    baseUtcOffset: 'PT2H',
    displayName: '(UTC+02:00) Athens, Bucharest',
    id: 'GTB Standard Time',
    offset: 120
  },
  {
    baseUtcOffset: 'PT2H',
    displayName: '(UTC+02:00) Beirut',
    id: 'Middle East Standard Time',
    offset: 120
  },
  {
    baseUtcOffset: 'PT2H',
    displayName: '(UTC+02:00) Cairo',
    id: 'Egypt Standard Time',
    offset: 120
  },
  {
    baseUtcOffset: 'PT2H',
    displayName: '(UTC+02:00) Chisinau',
    id: 'E. Europe Standard Time',
    offset: 120
  },
  {
    baseUtcOffset: 'PT2H',
    displayName: '(UTC+02:00) Damascus',
    id: 'Syria Standard Time',
    offset: 120
  },
  {
    baseUtcOffset: 'PT2H',
    displayName: '(UTC+02:00) Gaza, Hebron',
    id: 'West Bank Standard Time',
    offset: 120
  },
  {
    baseUtcOffset: 'PT2H',
    displayName: '(UTC+02:00) Harare, Pretoria',
    id: 'South Africa Standard Time',
    offset: 120
  },
  {
    baseUtcOffset: 'PT2H',
    displayName: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
    id: 'FLE Standard Time',
    offset: 120
  },
  {
    baseUtcOffset: 'PT2H',
    displayName: '(UTC+02:00) Jerusalem',
    id: 'Israel Standard Time',
    offset: 120
  },
  {
    baseUtcOffset: 'PT2H',
    displayName: '(UTC+02:00) Kaliningrad',
    id: 'Kaliningrad Standard Time',
    offset: 120
  },
  {
    baseUtcOffset: 'PT2H',
    displayName: '(UTC+02:00) Khartoum',
    id: 'Sudan Standard Time',
    offset: 120
  },
  {
    baseUtcOffset: 'PT2H',
    displayName: '(UTC+02:00) Tripoli',
    id: 'Libya Standard Time',
    offset: 120
  },
  {
    baseUtcOffset: 'PT2H',
    displayName: '(UTC+02:00) Windhoek',
    id: 'Namibia Standard Time',
    offset: 120
  },
  {
    baseUtcOffset: 'PT3H',
    displayName: '(UTC+03:00) Baghdad',
    id: 'Arabic Standard Time',
    offset: 180
  },
  {
    baseUtcOffset: 'PT3H',
    displayName: '(UTC+03:00) Istanbul',
    id: 'Turkey Standard Time',
    offset: 180
  },
  {
    baseUtcOffset: 'PT3H',
    displayName: '(UTC+03:00) Kuwait, Riyadh',
    id: 'Arab Standard Time',
    offset: 180
  },
  {
    baseUtcOffset: 'PT3H',
    displayName: '(UTC+03:00) Minsk',
    id: 'Belarus Standard Time',
    offset: 180
  },
  {
    baseUtcOffset: 'PT3H',
    displayName: '(UTC+03:00) Moscow, St. Petersburg',
    id: 'Russian Standard Time',
    offset: 180
  },
  {
    baseUtcOffset: 'PT3H',
    displayName: '(UTC+03:00) Nairobi',
    id: 'E. Africa Standard Time',
    offset: 180
  },
  {
    baseUtcOffset: 'PT3H30M',
    displayName: '(UTC+03:30) Tehran',
    id: 'Iran Standard Time',
    offset: 210
  },
  {
    baseUtcOffset: 'PT4H',
    displayName: '(UTC+04:00) Abu Dhabi, Muscat',
    id: 'Arabian Standard Time',
    offset: 240
  },
  {
    baseUtcOffset: 'PT4H',
    displayName: '(UTC+04:00) Astrakhan, Ulyanovsk',
    id: 'Astrakhan Standard Time',
    offset: 240
  },
  {
    baseUtcOffset: 'PT4H',
    displayName: '(UTC+04:00) Baku',
    id: 'Azerbaijan Standard Time',
    offset: 240
  },
  {
    baseUtcOffset: 'PT4H',
    displayName: '(UTC+04:00) Izhevsk, Samara',
    id: 'Russia Time Zone 3',
    offset: 240
  },
  {
    baseUtcOffset: 'PT4H',
    displayName: '(UTC+04:00) Port Louis',
    id: 'Mauritius Standard Time',
    offset: 240
  },
  {
    baseUtcOffset: 'PT4H',
    displayName: '(UTC+04:00) Saratov',
    id: 'Saratov Standard Time',
    offset: 240
  },
  {
    baseUtcOffset: 'PT4H',
    displayName: '(UTC+04:00) Tbilisi',
    id: 'Georgian Standard Time',
    offset: 240
  },
  {
    baseUtcOffset: 'PT4H',
    displayName: '(UTC+04:00) Volgograd',
    id: 'Volgograd Standard Time',
    offset: 240
  },
  {
    baseUtcOffset: 'PT4H',
    displayName: '(UTC+04:00) Yerevan',
    id: 'Caucasus Standard Time',
    offset: 240
  },
  {
    baseUtcOffset: 'PT4H30M',
    displayName: '(UTC+04:30) Kabul',
    id: 'Afghanistan Standard Time',
    offset: 270
  },
  {
    baseUtcOffset: 'PT5H',
    displayName: '(UTC+05:00) Ashgabat, Tashkent',
    id: 'West Asia Standard Time',
    offset: 300
  },
  {
    baseUtcOffset: 'PT5H',
    displayName: '(UTC+05:00) Ekaterinburg',
    id: 'Ekaterinburg Standard Time',
    offset: 300
  },
  {
    baseUtcOffset: 'PT5H',
    displayName: '(UTC+05:00) Islamabad, Karachi',
    id: 'Pakistan Standard Time',
    offset: 300
  },
  {
    baseUtcOffset: 'PT5H',
    displayName: '(UTC+05:00) Qyzylorda',
    id: 'Qyzylorda Standard Time',
    offset: 300
  },
  {
    baseUtcOffset: 'PT5H30M',
    displayName: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    id: 'India Standard Time',
    offset: 330
  },
  {
    baseUtcOffset: 'PT5H30M',
    displayName: '(UTC+05:30) Sri Jayawardenepura',
    id: 'Sri Lanka Standard Time',
    offset: 330
  },
  {
    baseUtcOffset: 'PT5H45M',
    displayName: '(UTC+05:45) Kathmandu',
    id: 'Nepal Standard Time',
    offset: 345
  },
  {
    baseUtcOffset: 'PT6H',
    displayName: '(UTC+06:00) Astana',
    id: 'Central Asia Standard Time',
    offset: 360
  },
  {
    baseUtcOffset: 'PT6H',
    displayName: '(UTC+06:00) Dhaka',
    id: 'Bangladesh Standard Time',
    offset: 360
  },
  {
    baseUtcOffset: 'PT6H',
    displayName: '(UTC+06:00) Omsk',
    id: 'Omsk Standard Time',
    offset: 360
  },
  {
    baseUtcOffset: 'PT6H30M',
    displayName: '(UTC+06:30) Yangon (Rangoon)',
    id: 'Myanmar Standard Time',
    offset: 390
  },
  {
    baseUtcOffset: 'PT7H',
    displayName: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
    id: 'SE Asia Standard Time',
    offset: 420
  },
  {
    baseUtcOffset: 'PT7H',
    displayName: '(UTC+07:00) Barnaul, Gorno-Altaysk',
    id: 'Altai Standard Time',
    offset: 420
  },
  {
    baseUtcOffset: 'PT7H',
    displayName: '(UTC+07:00) Hovd',
    id: 'W. Mongolia Standard Time',
    offset: 420
  },
  {
    baseUtcOffset: 'PT7H',
    displayName: '(UTC+07:00) Krasnoyarsk',
    id: 'North Asia Standard Time',
    offset: 420
  },
  {
    baseUtcOffset: 'PT7H',
    displayName: '(UTC+07:00) Novosibirsk',
    id: 'N. Central Asia Standard Time',
    offset: 420
  },
  {
    baseUtcOffset: 'PT7H',
    displayName: '(UTC+07:00) Tomsk',
    id: 'Tomsk Standard Time',
    offset: 420
  },
  {
    baseUtcOffset: 'PT8H',
    displayName: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
    id: 'China Standard Time',
    offset: 480
  },
  {
    baseUtcOffset: 'PT8H',
    displayName: '(UTC+08:00) Irkutsk',
    id: 'North Asia East Standard Time',
    offset: 480
  },
  {
    baseUtcOffset: 'PT8H',
    displayName: '(UTC+08:00) Kuala Lumpur, Singapore',
    id: 'Singapore Standard Time',
    offset: 480
  },
  {
    baseUtcOffset: 'PT8H',
    displayName: '(UTC+08:00) Perth',
    id: 'W. Australia Standard Time',
    offset: 480
  },
  {
    baseUtcOffset: 'PT8H',
    displayName: '(UTC+08:00) Taipei',
    id: 'Taipei Standard Time',
    offset: 480
  },
  {
    baseUtcOffset: 'PT8H',
    displayName: '(UTC+08:00) Ulaanbaatar',
    id: 'Ulaanbaatar Standard Time',
    offset: 480
  },
  {
    baseUtcOffset: 'PT8H45M',
    displayName: '(UTC+08:45) Eucla',
    id: 'Aus Central W. Standard Time',
    offset: 525
  },
  {
    baseUtcOffset: 'PT9H',
    displayName: '(UTC+09:00) Chita',
    id: 'Transbaikal Standard Time',
    offset: 540
  },
  {
    baseUtcOffset: 'PT9H',
    displayName: '(UTC+09:00) Osaka, Sapporo, Tokyo',
    id: 'Tokyo Standard Time',
    offset: 540
  },
  {
    baseUtcOffset: 'PT9H',
    displayName: '(UTC+09:00) Pyongyang',
    id: 'North Korea Standard Time',
    offset: 540
  },
  {
    baseUtcOffset: 'PT9H',
    displayName: '(UTC+09:00) Seoul',
    id: 'Korea Standard Time',
    offset: 540
  },
  {
    baseUtcOffset: 'PT9H',
    displayName: '(UTC+09:00) Yakutsk',
    id: 'Yakutsk Standard Time',
    offset: 540
  },
  {
    baseUtcOffset: 'PT9H30M',
    displayName: '(UTC+09:30) Adelaide',
    id: 'Cen. Australia Standard Time',
    offset: 570
  },
  {
    baseUtcOffset: 'PT9H30M',
    displayName: '(UTC+09:30) Darwin',
    id: 'AUS Central Standard Time',
    offset: 570
  },
  {
    baseUtcOffset: 'PT10H',
    displayName: '(UTC+10:00) Brisbane',
    id: 'E. Australia Standard Time',
    offset: 600
  },
  {
    baseUtcOffset: 'PT10H',
    displayName: '(UTC+10:00) Canberra, Melbourne, Sydney',
    id: 'AUS Eastern Standard Time',
    offset: 600
  },
  {
    baseUtcOffset: 'PT10H',
    displayName: '(UTC+10:00) Guam, Port Moresby',
    id: 'West Pacific Standard Time',
    offset: 600
  },
  {
    baseUtcOffset: 'PT10H',
    displayName: '(UTC+10:00) Hobart',
    id: 'Tasmania Standard Time',
    offset: 600
  },
  {
    baseUtcOffset: 'PT10H',
    displayName: '(UTC+10:00) Vladivostok',
    id: 'Vladivostok Standard Time',
    offset: 600
  },
  {
    baseUtcOffset: 'PT10H30M',
    displayName: '(UTC+10:30) Lord Howe Island',
    id: 'Lord Howe Standard Time',
    offset: 630
  },
  {
    baseUtcOffset: 'PT11H',
    displayName: '(UTC+11:00) Bougainville Island',
    id: 'Bougainville Standard Time',
    offset: 660
  },
  {
    baseUtcOffset: 'PT11H',
    displayName: '(UTC+11:00) Chokurdakh',
    id: 'Russia Time Zone 10',
    offset: 660
  },
  {
    baseUtcOffset: 'PT11H',
    displayName: '(UTC+11:00) Magadan',
    id: 'Magadan Standard Time',
    offset: 660
  },
  {
    baseUtcOffset: 'PT11H',
    displayName: '(UTC+11:00) Norfolk Island',
    id: 'Norfolk Standard Time',
    offset: 660
  },
  {
    baseUtcOffset: 'PT11H',
    displayName: '(UTC+11:00) Sakhalin',
    id: 'Sakhalin Standard Time',
    offset: 660
  },
  {
    baseUtcOffset: 'PT11H',
    displayName: '(UTC+11:00) Solomon Is., New Caledonia',
    id: 'Central Pacific Standard Time',
    offset: 660
  },
  {
    baseUtcOffset: 'PT12H',
    displayName: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky',
    id: 'Russia Time Zone 11',
    offset: 720
  },
  {
    baseUtcOffset: 'PT12H',
    displayName: '(UTC+12:00) Auckland, Wellington',
    id: 'New Zealand Standard Time',
    offset: 720
  },
  {
    baseUtcOffset: 'PT12H',
    displayName: '(UTC+12:00) Coordinated Universal Time+12',
    id: 'UTC+12',
    offset: 720
  },
  {
    baseUtcOffset: 'PT12H',
    displayName: '(UTC+12:00) Fiji',
    id: 'Fiji Standard Time',
    offset: 720
  },
  {
    baseUtcOffset: 'PT12H',
    displayName: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old',
    id: 'Kamchatka Standard Time',
    offset: 720
  },
  {
    baseUtcOffset: 'PT12H45M',
    displayName: '(UTC+12:45) Chatham Islands',
    id: 'Chatham Islands Standard Time',
    offset: 765
  },
  {
    baseUtcOffset: 'PT13H',
    displayName: '(UTC+13:00) Coordinated Universal Time+13',
    id: 'UTC+13',
    offset: 780
  },
  {
    baseUtcOffset: 'PT13H',
    displayName: "(UTC+13:00) Nuku'alofa",
    id: 'Tonga Standard Time',
    offset: 780
  },
  {
    baseUtcOffset: 'PT13H',
    displayName: '(UTC+13:00) Samoa',
    id: 'Samoa Standard Time',
    offset: 780
  },
  {
    baseUtcOffset: 'PT14H',
    displayName: '(UTC+14:00) Kiritimati Island',
    id: 'Line Islands Standard Time',
    offset: 840
  }
];
